<template>
    <div class="col-12 px-0">
        <Password :label="passwordLabel.newPassword" :get-password-id="getPasswordRequirementsId('requirement')" :in-error="inNewPasswordError || (password != '' && !allRequirementsMet)" override-valid="true" @update-password="updatePassword" @blur-password="onNewPasswordBlur"></Password>
        <p v-if="inNewPasswordError" class="error-msg mb-2" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{passwordLabel.requiredEntry}}</p>
        <Password :label="verifyPasswordLabel" name="verifyPassword" :in-error="Boolean(inVerifyPasswordError)" override-valid="true" @update-password="updateVerify" @blur-password="onVerifyPasswordBlur"></Password>
        <p v-if="inVerifyPasswordError" class="error-msg mb-2" role="alert" aria-live="assertive"><fa-icon :icon="['fas', 'exclamation-triangle']" class="mr-1" />{{inVerifyPasswordError}}</p>
        <span v-if="allRequirementsMet" class="sr-only" role="alert" aria-live="assertive">{{passwordLabel.passwordRequirementMet}}</span>
        <span v-else class="sr-only" role="alert" aria-live="assertive">{{passwordLabel.passwordRequirementNotMet}}</span>
        <div class="col-12 px-0 mb-3">
            <p class="font-weight-bold">{{requirementsLabel}}</p>
            <span class="sr-only" :id="getPasswordRequirementsId('requirement')">{{unmatchedRequirement}}</span>
            <ul class="userRquirements">
                <template v-for="requirement in requirements">
                    <li :aria-hidden="String(requirementsMet[requirement.type].valid != 'info')" v-if="requirementsMet[requirement.type].display" class="m-0">
                        <span v-if="requirementsMet[requirement.type].valid == true"><fa-icon :icon="['fas','check-circle']" class="met"></fa-icon></span>
                        <span v-else-if="requirementsMet[requirement.type].valid == false"><fa-icon :icon="['fas','times-circle']" class="unmet"></fa-icon></span>
                        <span v-else><fa-icon :icon="['fas','info-circle']" class="info"></fa-icon></span>
                        {{substitution(requirement.text)}}
                    </li>
                </template>
            </ul>
        </div>
    </div>
</template>

<script>
    import Password from './Password.vue';
    let instanceCount = 0;

    export default {
        name: "NewPassword",

        emits: ['set-new-password'],

        components: {
            Password
        },

        props: {
            passwordLabel: Object,
            verifyPasswordLabel: String,
            requirementsLabel: String,
            userId: {
                type: String,
                default: null
            }
        },

        data: function() {
            return {
                password: "",
                verifyPassword: "",
                allRequirementsMet: false,
                requirementsMet: {},
                requirements: this.getPasswordRequirements(),
                instanceId: `password-requirements-${instanceCount++}`,
                unmatchedRequirement: "",
                inNewPasswordError: null,
                inVerifyPasswordError: null
            }
        },

        methods: {
            getPasswordRequirementsId: function(type) {
             return `${this.instanceId}-${type}`;
            },

            substitution: function(item) {
                var parts = item.split(/(?<!\\)#/);
                for (var i=1; i < parts.length; i+=2) {
                    parts[i] = this.clientProfile[parts[i]];
                }
                return parts.join('').replace(/\\#/g, '#');
            },

            updatePassword: function(val) {
                this.password = val;
            },

            updateVerify: function(val) {
                this.verifyPassword = val; 
            },

            validatePassword: function() {
                for (var requirement in this.requirementsMet) {
                    let requirementDetails = this.requirementsMet[requirement];
                    if (requirementDetails.display && requirementDetails.valid != "info") {
                        this.setRequirementValid(requirement, this[requirementDetails.validate](requirement));
                    }
                }
            },

            setRequirementValid: function(requirementType, valid) {
                var requirementDetails = this.requirementsMet[requirementType];
                requirementDetails.valid = valid == null ? requirementDetails.valid : valid;
            },

            validateLength: function() {
                return this.clientProfile.passwordMinLengthCount <= this.password.length && this.password.length <= this.clientProfile.passwordMaxLengthCount;
            },

            validateMinAlpha: function() {
                var regex = new RegExp(/[a-zA-Z]/g);
                var match = this.password.match(regex);
                return match !== null && match.length >= this.clientProfile.passwordMinAlphabeticCharactersCount;
            },

            validateMinNumeric: function() {
                var regex = new RegExp(/[0-9]/g);
                var match = this.password.match(regex);
                return match !== null && match.length >= this.clientProfile.passwordMinNumericCharactersCount;
            },

            validateMinSpecial: function() {
                var regex = new RegExp(/[^a-zA-Z0-9]/g);
                var match = this.password.match(regex);
                return match !== null && match.length >= this.clientProfile.passwordMinSpecialCharactersCount;
            },

            validateMinNonAlpha: function() {
                var regex = new RegExp(/[^a-zA-Z]/g);
                var match = this.password.match(regex);
                return match !== null && match.length >= this.clientProfile.passwordMinNonAlphaCharactersCount;
            },

            validateMinNonNumeric: function() {
                var regex = new RegExp(/[^0-9]/g);
                var match = this.password.match(regex);
                return match !== null && match.length >= this.clientProfile.passwordMinNonNumericCharactersCount;
            },

            validateMinNonSpecial: function() {
                var regex = new RegExp(/[a-zA-Z0-9]/g);
                var match = this.password.match(regex);
                return match !== null && match.length >= this.clientProfile.passwordMinNonSpecialCharactersCount;
            },

            passwordDoesNotMatchUsername: function(requirementType){
                if(this.userId == null){
                    var API = `/BFWeb/cwapi/${this.getClient()}/credentials/username`;
                    this.$axios.get(API).then((response) => {
                        const existingUsername = atob(response.data.data).toLowerCase();
                        const doesPasswordMatchUsername = this.password.toLowerCase() === existingUsername.toLowerCase();
                        this.setRequirementValid(requirementType, !Boolean(doesPasswordMatchUsername));
                    });
                }
                else{
                    return !(this.password.toLowerCase() === this.userId.toLowerCase());
                }
            },

            addRequirement: function(key, display, valid, callback) {
                var item = {
                    "display": display,
                    "valid": valid,
                    "validate": callback
                };

                Object.assign(this.requirementsMet, {[key]: item});
            },

            isNewPasswordValid: function() {
                return this.password !== "";
            },
            
            //if invalid will return string indicating error message else if valid will return true
            isVerifyPasswordValid: function() {
                if(this.verifyPassword === "")
                    return this.passwordLabel.requiredEntry;
                else if(this.verifyPassword !== this.password)
                    return this.passwordLabel.passwordNotMatched;
                
                return true;
            },

            onNewPasswordBlur: function() {
                this.setInNewPasswordError();
                if(this.verifyPassword != "")
                    this.setInVerifyPasswordError();
            },

            onVerifyPasswordBlur: function() {
                this.setInVerifyPasswordError();
            },

            setInNewPasswordError: function() {
                this.inNewPasswordError = !(this.isNewPasswordValid());
            },

            setInVerifyPasswordError: function(){
                var isValid = this.isVerifyPasswordValid();
                this.inVerifyPasswordError = isValid === true ? false : isValid;
            },

            validateAndEmitPassword: function () {
                this.emitPassword(this.allRequirementsMet && this.isNewPasswordValid() && this.isVerifyPasswordValid() === true ? this.password : "");
            },

            emitPassword: function(val){
                this.$emit('set-new-password', val);
            }
        },

        watch: {
            password: function() {
                this.validatePassword();
                this.inNewPasswordError = false;
                this.inVerifyPasswordError = false;
                this.validateAndEmitPassword();
            },

            verifyPassword: function() {     
                this.inVerifyPasswordError = false;   
                this.validateAndEmitPassword();
            },

            allRequirementsMet: function() {
                this.validateAndEmitPassword();
            },

            requirementsMet: {
                deep: true,
                handler: function(val) {
                    var allRequirementsMet = true;
                    var unmatchedRequirement = [];

                    for (var requirement in val) {
                        if (val[requirement].display && !val[requirement].valid) {
                            allRequirementsMet = false;
                            unmatchedRequirement.push(this.substitution(
                            this.requirements.find(({type}) => type == requirement).text
                            ));
                        }
                    }

                    this.allRequirementsMet = allRequirementsMet;
                    this.unmatchedRequirement = unmatchedRequirement.join(';');
                }
            }
        },

        created: function() {
            this.clientProfile = this.getClientProfile();
            this.addRequirement('length', true, false, "validateLength");
            this.addRequirement('minAlpha', this.clientProfile.passwordMinAlphabeticCharactersCount > 0, false, "validateMinAlpha");
            this.addRequirement('minNumeric', this.clientProfile.passwordMinNumericCharactersCount > 0, false, "validateMinNumeric");
            this.addRequirement('minSpecial', this.clientProfile.passwordMinSpecialCharactersCount > 0, false, "validateMinSpecial");
            this.addRequirement('minNonAlpha', this.clientProfile.passwordMinNonAlphaCharactersCount > 0, false, "validateMinNonAlpha");
            this.addRequirement('minNonNumeric', this.clientProfile.passwordMinNonNumericCharactersCount > 0, false, "validateMinNonNumeric");
            this.addRequirement('minNonSpecial', this.clientProfile.passwordMinNonSpecialCharactersCount > 0, false, "validateMinNonSpecial");
            this.addRequirement('passwordDonotNotMatchUsername', true, false, "passwordDoesNotMatchUsername");
            this.addRequirement('caseInSensitive', true, "info");
        },

        inject: [
            'getClientProfile',
            'getPasswordRequirements',
            'getClient'
        ]
    }
</script>

<style scoped>
    .met {
        color: #43a047;
    }

    .unmet {
        color: var(--priority-color);
    }

    .userRquirements{
        font-size: 14px;
    }
</style>